import type { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';

import { SearchInput } from '@kanda-libs/ks-component-ts';
import { Button } from '@kanda-libs/ks-design-library';

import { URLS } from 'components/shared/App/constants';
import InfoBanner from 'components/shared/InfoBanner';
import PageTitle from 'components/shared/PageTitle';
import PresetFilter, {
  PresetFilterOption,
} from 'components/shared/PresetFilter';
import useQuery from 'hooks/useQuery';

export interface CompaniesListPageInfoBannerProps {
  toggleValue: (key: string) => void;
}

const CompaniesListPageInfoBanner: FunctionComponent<CompaniesListPageInfoBannerProps> =
  function () {
    const [query, setQuery] = useQuery('companies');
    const currentPath = window.location.href
      .split(window.location.host)[1]
      .split('?')[0];

    const options: PresetFilterOption[] = [
      { value: URLS.companies, text: 'Verified' },
      { value: URLS.companiesCompletedSetup, text: 'Completed Setup' },
      { value: URLS.companiesOngoing, text: 'Ongoing' },
      { value: URLS.companiesAll, text: 'All' },
    ];

    return (
      <>
        <PageTitle>Companies</PageTitle>
        <PresetFilter
          menuItem="companies"
          currentPath={currentPath}
          options={options}
        />
        <div className="mb-2" />
        <InfoBanner
          title="Companies"
          backArrow={false}
          search={<SearchInput query={query} onSearch={setQuery} />}
        >
          <Link to={URLS.companiesAddCompany} className="ml-auto">
            <Button.Text label="Add new company" id="staff-add-new-company" />
          </Link>
        </InfoBanner>
      </>
    );
  };

export default CompaniesListPageInfoBanner;
